import React from 'react';
import { Award, Globe, ShieldCheck, Smile, Stethoscope } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const TrustStripSection = () => {
  const { t } = useLanguage();

  const stats = [
    { Icon: Smile, value: '5,000+', label: t('trustStrip.patients', 'Happy Patients') },
    { Icon: Stethoscope, value: '15+', label: t('trustStrip.years', 'Years of Experience') },
    { Icon: Globe, value: '50+', label: t('trustStrip.countries', 'Countries Served') },
    { Icon: ShieldCheck, value: '10', label: t('trustStrip.warranty', 'Years Warranty') },
    { Icon: Award, value: 'ISO', label: t('trustStrip.iso', 'ISO 9001') },
  ];

  return (
    <section className="trust-strip" aria-label="Our results in numbers">
      <div className="container-premium">
        <ul className="trust-strip-grid">
          {stats.map(({ Icon, value, label }) => (
            <li key={label} className="trust-strip-item">
              <Icon size={22} className="trust-strip-icon" />
              <div className="trust-strip-text">
                <strong>{value}</strong>
                <span>{label}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustStripSection;
